import { render, staticRenderFns } from "./MPInternationalization.vue?vue&type=template&id=4d7925f9&"
import script from "./MPInternationalization.vue?vue&type=script&lang=js&"
export * from "./MPInternationalization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports